import entry from '@rtl/ssr/client'

import createApp from './app'

entry(createApp)
